import { compose } from 'coact/recompose'

import View from './FilterList.jsx'

const FilterList = compose()(View)

FilterList.displayName = 'FilterList'

export default FilterList
